export interface ClientErrorLog {
  page?: string
  component?: string
  errorType: string
  endpoint?: string
  timestamp: string
}

/** Registro de errores para diagnóstico. Únicamente componente/página/tipo/timestamp/endpoint
 * -- nunca tokens, cookies, headers ni datos personales. Punto único usado por el
 * ErrorBoundary y por el interceptor de `apiClient`, para no duplicar el criterio de qué es
 * seguro loguear. */
export function logClientError(entry: Omit<ClientErrorLog, 'timestamp'>): void {
  const log: ClientErrorLog = { ...entry, timestamp: new Date().toISOString() }
  // eslint-disable-next-line no-console
  console.error('[Mini App Error]', log)
}
